export default {
  heroSlide1Title: "Accelerating Healthcare from Lab to Life",
  heroSlide1Subtitle: "Leading pharmaceutical innovation with 40+ years of expertise in psychotropic APIs and complex generics",
  heroSlide2Title: "Global Reach – Customers in 80+ countries",
  heroSlide2Subtitle: "Building strong relationships with top pharma innovators and generics companies worldwide",
  heroSlide3Title: "From Building Blocks to Formulations: One Partner. Total Reliability",
  heroSlide3Subtitle: "End-to-end pharmaceutical solutions with integrated value chain across KSM, APIs, and FDFs",
  heroSlide4Title: "6 Global Facilities | 4 R&D Centres | 1 Global Pharma Platform",
  heroSlide4Subtitle: "World-class manufacturing and research infrastructure driving innovation and quality excellence",
  heroSlide5Title: "Our Group Companies",
  heroSlide5Subtitle: "A diverse portfolio of companies working together to deliver comprehensive pharmaceutical solutions",
};

